<template>
  <div class="reward">
    <div class="main-title">使用帮助/互动功能/打赏</div>
    <h1 class="page-title">打赏</h1>
    <h4 class="content-text">用户还可以在手机端打赏喜欢的歌手。</h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-reward1_1768288350326a7f634.webp"
      alt="酒吧大屏互动扫打赏歌手"
      class="mobile-image"
    />
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-reward2_17682883503261a6455.webp"
      alt="酒吧大屏互动打赏送礼赞扬"
      class="mobile-image"
    />
  </div>
</template>

<script>
export default {
  name: 'Reward',
};
</script>

<style lang="less" scoped>
.reward {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.main-title {
  width: 100%;
  font-weight: 500;
  font-size: 20px;
  color: #E19BFF;
  text-align: left;
  margin-top: 10px;
  padding-bottom: 12px;
  border-bottom: 1px solid #E19BFF;
}

.page-title {
  width: 100%;
  font-weight: 700;
  font-size: 32px;
  color: #FFFFFF;
  text-align: left;
  margin-top: 10px;
}

.content-text {
  width: 100%;
  font-weight: 400;
  font-size: 15px;
  color: #FFFFFF;
  text-align: left;
  word-wrap: break-word;
  word-break: break-all;
  margin-top: 10px;
}

.mobile-image {
  width: 241px;
  height: auto;
  margin: 10px auto;
  display: block;
}
</style>
